import { useQuery } from 'react-query';
import { performanceReportingApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import { AssignedModule } from '../_types';

const url = `${performanceReportingApiUrl()}/performance/templates/v1/assigned-modules`;

export const getAssignedModules = async (onError?: (errors: ServerErrorResponse) => void) => {
  try {
    const data = await fetcher({
      method: 'GET',
      url,
    });
    return data;
  } catch (error: unknown) {
    if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
      onError(error as ServerErrorResponse);
    }
    throw error;
  }
};

export default function useAssignedModules(options = {}, onError?: (errors: ServerErrorResponse) => void) {
  return useQuery<AssignedModule[], ServerErrorResponse>(
    ['assigned-modules'],
    async () => getAssignedModules(onError),
    {
      keepPreviousData: false,
      ...options,
    }
  );
}
